module.exports = __webpack_public_path__ + "img/carousel-arrow-right.46491336.svg";